module.exports = __webpack_public_path__ + "media/images/icons/icon_help-990be922b54b1ae0c1d73ebd32835e5a.svg";